import React, { useEffect } from "react";
import axios from "axios";

import { useDispatch } from "react-redux";

import { setProducts } from "../redux/actions/productsActions";

import { ProductComponent } from '../components';

const ProductListing = () => {
    const dispatch = useDispatch();

    const fetchProducts = async () => {
        const response = await axios
            .get("https://fakestoreapi.com/products")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setProducts(response.data));
    };

    useEffect(() => {
        fetchProducts()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="ui grid container">
            <ProductComponent />
        </div>
    );
}

export default ProductListing